/**
 * La fecha de una orden o compra, como se lee: "26 ago 2026".
 *
 * El instante viaja en ISO por el contrato; el formato es de la
 * pantalla. Un ISO ilegible —que no debería pasar el contrato— se
 * devuelve tal cual en vez de reventar la tabla entera.
 */
const FORMATTER = new Intl.DateTimeFormat("es-MX", { dateStyle: "medium" });

export function formatOrderDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return FORMATTER.format(date);
}

/**
 * Fecha COMPLETA con hora: "14 sep 2026, 21:31" (Anahí, 14-sep: «día,
 * mes, año y hasta la hora, para tener todo controlado»). Es la que va
 * en el libro de comisiones, donde dos asientos del mismo día se
 * distinguen solo por la hora.
 */
const DATETIME_FORMATTER = new Intl.DateTimeFormat("es-MX", {
  dateStyle: "medium",
  timeStyle: "short",
  timeZone: "America/Mexico_City",
});

export function formatOrderDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return DATETIME_FORMATTER.format(date);
}
